import { emitScrollEvent } from "./eventEmitter";

const buildCinema = (cinemaTracking, featureIndex, cinemaIndex, additionalTrackingLabels) => {
    const { labels } = cinemaTracking;
    const parsedCinemaIndex = Number.parseInt(cinemaIndex, 10);
    const featureNumber = Number.isNaN(parsedCinemaIndex)
        ? undefined
        : parsedCinemaIndex === 99
          ? 99
          : parsedCinemaIndex + 1;

    return {
        ...cinemaTracking,
        position: parseInt(featureIndex, 10),
        status: "visible",
        labels: {
            ...labels,
            ...(featureNumber && { promo_FeatureNumber: [`${featureNumber}`] }),
            promo_FilledSlots: labels.promo_FilledSlots,
            ...additionalTrackingLabels,
        },
    };
};
const buildRecommendations = (recommendationsTracking) => {
    return recommendationsTracking.map((tracking) => ({
        ...tracking,
        status: "visible",
    }));
};

const initializeRow = (numberOfColumns) => {
    let data = [];

    for (let i = 0; i < numberOfColumns; i++) {
        data.push("");
    }
    return data;
};

const mergeToPayload = (table) => {
    let payload = {};
    for (let pair of Object.entries(table)) {
        payload[pair[0]] = [pair[1].join("|")];
    }
    return payload;
};

const buildTrackingLabels = (tiles) => {
    const table = {};
    const numberOfColumns = tiles.length;
    for (let i = 0; i < tiles.length; i++) {
        let currentTile = tiles[i];
        for (let property of Object.entries(currentTile)) {
            if (!property[1]) {
                continue;
            }
            if (!table[property[0]]) {
                table[property[0]] = initializeRow(numberOfColumns);
            }
            table[property[0]][i] = property[1];
        }
    }
    return mergeToPayload(table);
};

export default (
    cinemaTracking,
    recommendationsTracking,
    featureIndex,
    cinemaIndex,
    scrollDirection,
    cinemaMeta,
    recommendationsMeta,
    sourceVariationId,
    additionalTrackingLabels
) => {
    const event = {
        name: scrollDirection,
        features: [
            buildCinema(cinemaTracking, featureIndex, cinemaIndex, additionalTrackingLabels),
            ...buildRecommendations(recommendationsTracking),
        ],
    };

    const productVariationId = {
        product_VariationId: [sourceVariationId],
    };
    const cleanRecommendationsMeta = recommendationsMeta.map((recommendationMeta) => {
        const cleanRecommendationMeta = { ...recommendationMeta };
        delete cleanRecommendationMeta.product_VariationId;
        return cleanRecommendationMeta;
    });
    const additionalRecommendationsTrackingLabels = buildTrackingLabels(cleanRecommendationsMeta);
    const additionalScrollTrackingLabels = {
        ...additionalRecommendationsTrackingLabels,
        ...cinemaMeta,
        ...productVariationId,
    };
    emitScrollEvent(event, additionalScrollTrackingLabels);
};
